import { jsx } from "react/jsx-runtime";
import { Button } from "@zillow/constellation-10";
import { yieldCallback } from "@zillow/yield-callback";
import { useFormContext } from "react-hook-form";
import { FieldConfig } from "./AffordabilityCalculator.utils.esm.js";
import { trackLabel } from "./trackLabel.esm.js";
const FullReportButton = () => {
  const form = useFormContext();
  return /* @__PURE__ */ jsx(Button, { css: {
    position: "absolute",
    top: "0",
    right: "md",
    zIndex: 10,
    display: {
      base: "block",
      mdDown: "none"
    }
  }, type: "button", tone: "brand", emphasis: "outlined", size: "sm", onClick: yieldCallback(() => {
    const values = form.getValues();
    const url = new URL("https://www.zillow.com/mortgage/calculator/affordability/advanced-report/");
    url.searchParams.set("annualIncome", values[FieldConfig.annualIncome.name]);
    url.searchParams.set("monthlyDebts", values[FieldConfig.monthlyDebts.name]);
    url.searchParams.set("customPayment", values[FieldConfig.customPayment.name]);
    url.searchParams.set("monthlyPayment", values[FieldConfig.monthlyPayment.name]);
    url.searchParams.set("monthlyPaymentMax", values[FieldConfig.maximumPayment.name]);
    url.searchParams.set("downPayment", values[FieldConfig.downPayment.name]);
    url.searchParams.set("dti", values[FieldConfig.dti.name]);
    url.searchParams.set("rate", values[FieldConfig.rate.name]);
    url.searchParams.set("term", values[FieldConfig.term.name]);
    url.searchParams.set("includeTaxesInsurance", values[FieldConfig.includeTaxesInsurance.name]);
    url.searchParams.set("propertyTaxRate", values[FieldConfig.propertyTaxRate.name]);
    url.searchParams.set("annualHomeownersInsurance", values[FieldConfig.annualHomeownersInsurance.name]);
    url.searchParams.set("includePMI", values[FieldConfig.includePMI.name]);
    url.searchParams.set("monthlyHOA", values[FieldConfig.monthlyHOA.name]);
    window.open(url.toString(), "_blank");
    trackLabel("Advanced Report Click");
  }), children: "Full report" });
};
export {
  FullReportButton as default
};
